import axiosClient from './axiosClient';

const SurveyCategoryApi = {
  getDropdown: (data = {}) => {
    return axiosClient.post('/api/category/dropdown', data);
  },
  getById: (id) => {
    return axiosClient.post('/api/category/get', { id });
  },
  getList: (data) => {
    const url = `/api/category/list`;
    return axiosClient.post(url, data);
  },
  createSurveyCategory: (data) => {
    const url = `/api/category/create`;
    return axiosClient.post(url, data);
  },
  update: (data) => {
    const url = `/api/category/update`;
    return axiosClient.post(url, data);
  },
  delete: (id) => {
    const url = `/api/category/delete`;
    return axiosClient.post(url, { id });
  },
};

export default SurveyCategoryApi;
